import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { getAppInsights } from '.';
import { getAppConfig } from '../..';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function initializeApplicationInsights(shell, remotes) {
    //only initialize if the instrumentation key is defined
    const config = getAppConfig();
    if (config.REACT_APP_APPINSIGHTS_INSTR_KEY === undefined) {
        return;
    }
    const reactPlugin = new ReactPlugin();
    const appInsights = getAppInsights(new ApplicationInsights({
        config: {
            instrumentationKey: config.REACT_APP_APPINSIGHTS_INSTR_KEY,
            enableUnhandledPromiseRejectionTracking: false,
            autoTrackPageVisitTime: false,
            enableAutoRouteTracking: false,
            // Enable correlation
            enableCorsCorrelation: true,
            enableRequestHeaderTracking: false,
            enableResponseHeaderTracking: false,
            correlationHeaderExcludedDomains: [
                'launchdarkly.com',
                'localhost',
                'https://int.paymentui.sgicloud.ca',
                'https://parallel.paymentui.sgicloud.ca',
                'https://paymentui.sgicloud.ca',
                'https://maps.googleapis.com',
                ...(remotes?.map(remote => remote.url) ?? []),
            ],
            excludeRequestFromAutoTrackingPatterns: [
                'launchdarkly.com',
                'localhost',
                'https://int.paymentui.sgicloud.ca',
                'https://parallel.paymentui.sgicloud.ca',
                'https://paymentui.sgicloud.ca',
                'https://maps.googleapis.com',
                ...(remotes?.map(remote => remote.url) ?? []),
            ],
            // End of correlation config
            extensions: [reactPlugin],
        },
    }));
    appInsights.getValue().loadAppInsights();
    let cloudRoleName = '';
    if (config.REACT_APP_ENV === 'prd') {
        cloudRoleName = 'AF.Shell.UI';
    }
    else if (config.REACT_APP_ENV === 'par') {
        cloudRoleName = 'AF.Shell.UI-par';
    }
    else if (config.REACT_APP_ENV === 'int') {
        cloudRoleName = 'AF.Shell.UI-int';
    }
    else {
        cloudRoleName = 'AF.Shell.UI-Development';
    }
    appInsights.getValue().addTelemetryInitializer((envelope) => {
        envelope.tags = envelope.tags || [];
        // eslint-disable-next-line @typescript-eslint/naming-convention
        envelope.tags.push({ 'ai.cloud.role': cloudRoleName });
    });
}
